import React from "react";
import ISOHeader22000 from "../../../components/ISO Certificates/ISO 22000-2018/ISOHeader22000";
import ISOContent22000 from "../../../components/ISO Certificates/ISO 22000-2018/ISOContent22000";
import ISOServiceIndia9001 from "../../../components/ISO Certificates/ISO Common/ISOServiceIndia9001";
import ISOCertificationCost9001 from "../../../components/ISO Certificates/ISO Common/ISOCertificationCost9001";
import ISOBenifit9001 from "../../../components/ISO Certificates/ISO Common/ISOBenifit9001";

const ISO220002018 = () => {
  return (
    <div>
      <ISOHeader22000 />
      <ISOContent22000 />
      <ISOServiceIndia9001 />
      <ISOCertificationCost9001 />
      <ISOBenifit9001 />
    </div>
  );
};

export default ISO220002018;
